import { CheckboxInput } from '../baseInputs'

const PaymentConsent = () => {
  return (
    <div className="mt-8">
      <CheckboxInput name={'terms'} value="true">
        I have read and understand the terms above
      </CheckboxInput>
    </div>
  )
}

export default PaymentConsent
